import { useState, useEffect } from 'react';
import { FaCamera, FaStar, FaHotTub, FaMountain, FaFire, FaWifi } from 'react-icons/fa';

// Import Chalet Cristal images
import cristal1 from '../images/cristal1.jpeg';
import cristal2 from '../images/cristal2.jpeg';
import cristal3 from '../images/cristal3.jpeg';
import cristal4 from '../images/cristal4.jpeg';
import cristal5 from '../images/cristal5.jpeg';
import cristal6 from '../images/cristal6.jpeg';
import cristal7 from '../images/cristal7.jpeg';

// Import Chalet Safira images
import safira1 from '../images/safira1.jpeg';
import safira2 from '../images/safira2.jpeg';
import safira3 from '../images/safira3.jpeg';
import safira4 from '../images/safira4.jpeg';
import safira5 from '../images/safira5.jpeg';
import safira6 from '../images/safira6.jpeg';

const cristalImages = [
  cristal1, cristal2, cristal3, cristal4, cristal5,
  cristal6, cristal7
];

const safiraImages = [
  safira1, safira2, safira3, safira4, safira5, safira6
];

// Subconjunto de imagens para o carrossel automático (para não carregar todas de uma vez na animação)
const cristalCarousel = [cristal6, cristal1, cristal2, cristal4];
const safiraCarousel = [safira6, safira1, safira2, safira4];

const Experience = () => {
  const [activeGallery, setActiveGallery] = useState(null); // 'cristal', 'safira', or null
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [cristalIndex, setCristalIndex] = useState(0);
  const [safiraIndex, setSafiraIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCristalIndex((prev) => (prev + 1) % cristalCarousel.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setSafiraIndex((prev) => (prev + 1) % safiraCarousel.length);
    }, 5300); // Tempo levemente diferente para desencontro natural
    return () => clearInterval(interval);
  }, []);

  const openGallery = (gallery, index = 0) => {
    setActiveGallery(gallery);
    setCurrentImageIndex(index);
  };

  const closeGallery = () => {
    setActiveGallery(null);
  };

  const getCurrentImages = () => {
    if (activeGallery === 'cristal') return cristalImages;
    if (activeGallery === 'safira') return safiraImages;
    return [];
  };

  const images = getCurrentImages();

  const nextImage = (e) => {
    e.stopPropagation();
    if (images.length > 0) {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
    }
  };

  const prevImage = (e) => {
    e.stopPropagation();
    if (images.length > 0) {
      setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
    }
  };

  const scrollToBooking = () => {
    const bookingSection = document.querySelector('.booking-widget');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="experience-section" id="chalets">
      <h2>Nossos Chalés</h2>
      <div className="chalets-container">
        <div className="chalet-item">
          <div className="chalet-carousel" onClick={() => openGallery('cristal', 0)}>
            {cristalCarousel.map((img, index) => (
              <img 
                key={index} 
                src={img} 
                alt="Chalé Cristal" 
                className={`carousel-image ${index === cristalIndex ? 'active' : ''}`} 
              />
            ))}
          </div>
          <div className="chalet-info">
            <div className="chalet-header-row">
              <h3>Chalé Cristal</h3>
              <div className="chalet-rating">
                <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
              </div>
            </div>
            <div className="chalet-features-badges">
              <span className="feature-badge"><FaMountain /> Vista Panorâmica</span>
              <span className="feature-badge"><FaWifi /> Wi-Fi</span>
            </div>
            <p>O cenário perfeito para um romance a dois. Desfrute de um deck privativo com vista panorâmica de tirar o fôlego. Possui mesa externa exclusiva, ideal para cafés da manhã inesquecíveis e jantares românticos sob as estrelas.</p>
            <button className="btn-gallery-trigger" onClick={() => openGallery('cristal', 0)}>
              <FaCamera /> Ver Galeria de Fotos
            </button>
          </div>
        </div>
        <div className="chalet-item">
          <div className="chalet-carousel" onClick={() => openGallery('safira', 0)}>
            {safiraCarousel.map((img, index) => (
              <img 
                key={index} 
                src={img} 
                alt="Chalé Safira" 
                className={`carousel-image ${index === safiraIndex ? 'active' : ''}`} 
              />
            ))}
          </div>
          <div className="chalet-info">
            <div className="chalet-header-row">
              <h3>Chalé Safira</h3>
              <div className="chalet-rating">
                <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
              </div>
            </div>
            <div className="chalet-features-badges">
              <span className="feature-badge"><FaHotTub /> Jacuzzi</span>
              <span className="feature-badge"><FaFire /> Lareira</span>
            </div>
            <p>A experiência completa de luxo na montanha. Relaxe na Jacuzzi ou aqueça-se na lareira enquanto admira a vista monumental da Pedra do Baú. Conforto absoluto para momentos especiais.</p>
            <button className="btn-gallery-trigger" onClick={() => openGallery('safira', 0)}>
              <FaCamera /> Ver Galeria de Fotos
            </button>
          </div>
        </div>
      </div>

      <div className="experience-cta-container">
        <button className="section-cta" onClick={scrollToBooking}>
          Reservar
        </button>
      </div>

      {/* Gallery Modal */}
      {activeGallery && (
        <div className="gallery-modal" onClick={closeGallery}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-button" onClick={closeGallery}>&times;</button>
            <button className="nav-button prev" onClick={prevImage}>&#10094;</button>
            <img src={images[currentImageIndex]} alt={`Foto ${currentImageIndex + 1}`} className="modal-image" />
            <button className="nav-button next" onClick={nextImage}>&#10095;</button>
            <div className="image-counter">{currentImageIndex + 1} / {images.length}</div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Experience;
